import React from 'react';
import { Link } from 'react-router-dom';

import SetPasswordForm from './SetPasswordForm';
import HomeDecorator from './HomeDecorator';
import { ROUTE_LOGIN } from '../../constants/pathnames';

class SetPasswordView extends React.Component {
  constructor(props) {
    super(props);
    this._handleFormSubmit = this._handleFormSubmit.bind(this);
  }

  componentDidMount() {
    if (this.props.setPasswordFormLoaded) {
      this.props.setPasswordFormLoaded();
    }
  }

  render() {
    const { passwordResetError, isLoading, passwordReset } = this.props;

    return HomeDecorator(
      passwordReset ? (
        <div style={{ width: '100%' }}>
          <h2>Your password has been reset!</h2>
          <Link
            to={ROUTE_LOGIN}
            className="back-to-signin-button"
            style={{
              marginTop: 20,
              marginBottom: 'var(--spacing-sm)',
              border: '1px solid rgba(38, 94, 219, 0.5)',
              color: 'var(--color-primary-500)',
              fontSize: 'var(--font-size-base)',
              fontWeight: 'var(--font-weight-medium)',
              width: 'unset',
              borderRadius: 4,
              cursor: 'pointer',
              backgroundColor: 'white',
            }}
          >
            Back to Sign In
          </Link>
        </div>
      ) : (
        <SetPasswordForm onSubmit={this._handleFormSubmit} />
      ),

      passwordResetError,
      isLoading,
    );
  }

  _handleFormSubmit(data) {
    const { password } = data;

    const search = this.props.location.search;
    const code = search.substr(search.indexOf('?') + 1);
    this.props.setPassword(code, password);
  }
}

export default SetPasswordView;
